export default __webpack_public_path__ + "static/media/cds.8aadcc2a.jpg";